'use strict';

var debounce = require('lodash/debounce');

const elements = {
    $document: $(document)
};

const selectors = {
    footerGrid: '.js-grid-footer',
    tabBtn: '.js-tab-btn'
};

const classes = {
    disabled: 'disabled',
    active: 'active'
};

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom(results, selector) {
    var $updates = $(results).find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Handles active/disabled state of tabs, on page load
*/
function handleTabDisabledState() {
    const { disabled } = classes;

    if ($('.js-product-search').hasClass(disabled)) {
        getContent($('.js-content-search'), $('.js-content-search-results'));
    }
}

/**
 * Handles show more products
*/
function showMore() {
    const { $document } = elements;
    const { footerGrid } = selectors;

    $document.on('click', '.js-show-more-btn', debounce(function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $(footerGrid).replaceWith(response);
                updateDom(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }, 500));
}

/**
 * Handles content results
 */
function handleResultTabs() {
    const { $document } = elements;
    const { tabBtn } = selectors;
    const { active } = classes;

    $document.on('click', tabBtn, function(e) {
        e.preventDefault();
        const $this = $(this);
        const isContent = $this.hasClass('js-content-search');

        if ($this.hasClass('active')) {
            return;
        }

        $(tabBtn).removeClass(active);
        $this.addClass(active);

        if (isContent) {
            $('.js-product-search-results').hide();
            $('.js-content-search-results-pane').show();
        } else {
            $('.js-content-search-results-pane').hide();
            $('.js-product-search-results').show();
        }

        if ($('.js-content-search-results').html() === '') {
            getContent($(this), $('.js-content-search-results'));
        }
    });
}

/**
 * Display the next page of content results from the search
 */
function showMoreContent() {
    const { $document } = elements;

    $document.on('click', '.js-show-more-content-btn', function () {
        getContent($(this), $('.js-content-search-results'));
        $('.js-show-more-content').remove();
    });
}

module.exports = {
    showMore,
    handleResultTabs,
    handleTabDisabledState,
    showMoreContent
};
